export class MonitorFilter {
  fromDate: Date = null;
  untilDate: Date = null;
  dateType: FilterDateType = null;
  statusId: number = null;
  ticketType: number = null;
  ticketId: number = null;
  accountManagerId: number = null;
  fundCode: string = null;
  fundName: string = null;
  fundCnpj: string = null;
  settlementTypeId: number = null;
  operationTypeId: number = null;
  isOutstanding: boolean = false;
}

export enum FilterDateType {
  OperationDate = 1,
  SettlementDate = 2,
}
